import React, { useEffect, useState } from 'react';
import { useTranslations } from 'hooks/useTranslations';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { StyledPageTitle } from 'theme/styles';
import { ElabelsCaseManagement } from './helpers';
import Cases from './CasesPage';
import { TabMenu } from 'components/molecules/TabMenu';
import Dashboard from './Dashboard';
import Task from './Tasks';
import { useQuery } from 'hooks/useQuery';

export enum ETabId {
  task = 'task',
  applications = 'applications',
  dashboard = 'dashboard',
}

const CaseManagementPage = () => {
  const { t } = useTranslations();
  const query = useQuery();
  const expand: string | null = query.get('expand');

  const [defaultTab, setDefaultTab] = useState(0);

  const tabs = [
    {
      title: t(ElabelsCaseManagement.caseManagementDashboard),
      content: <Dashboard />,
    },
    {
      title: t(ElabelsCaseManagement.caseManagementCases),
      content: <Cases />,
    },
    {
      title: t(ElabelsCaseManagement.caseManagementTasks),
      content: <Task />,
    },
  ];

  useEffect(() => {
    if (expand) {
      switch (expand) {
        case ETabId.task:
          setDefaultTab(2);
          break;
        case ETabId.applications:
          setDefaultTab(1);
          break;
        case ETabId.dashboard:
          setDefaultTab(0);
          break;
        default:
          setDefaultTab(0);
          break;
      }
    }
  }, [expand]);

  return (
    <>
      <Breadcrumbs items={[t(ElabelsCaseManagement.caseManagementHeader)]} />
      <StyledPageTitle variant="h4">
        {t(ElabelsCaseManagement.caseManagementHeader)}
      </StyledPageTitle>
      <TabMenu tabs={tabs} defaultTab={defaultTab} />
    </>
  );
};

export default CaseManagementPage;
